var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5455 2.90909H26.1818V1.45455C26.1818 0.651222 25.5306 0 24.7273 0C23.9239 0 23.2727 0.651222 23.2727 1.45455V2.90909H17.4545V1.45455C17.4545 0.651222 16.8033 0 16 0C15.1967 0 14.5455 0.651222 14.5455 1.45455V2.90909H8.72727V1.45455C8.72727 0.651222 8.07605 0 7.27273 0C6.4694 0 5.81818 0.651222 5.81818 1.45455V2.90909H1.45455C0.651222 2.90909 0 3.56031 0 4.36364V30.5455C0 31.3488 0.651222 32 1.45455 32H30.5455C31.3488 32 32 31.3488 32 30.5455V4.36364C32 3.56031 31.3488 2.90909 30.5455 2.90909ZM2.90918 5.81763H5.81827V7.27217C5.81827 8.0755 6.46949 8.72672 7.27282 8.72672C8.07614 8.72672 8.72736 8.0755 8.72736 7.27217V5.81763H14.5455V7.27217C14.5455 8.0755 15.1968 8.72672 16.0001 8.72672C16.8034 8.72672 17.4546 8.0755 17.4546 7.27217V5.81763H23.2728V7.27217C23.2728 8.0755 23.924 8.72672 24.7274 8.72672C25.5307 8.72672 26.1819 8.0755 26.1819 7.27217V5.81763H29.091V11.6358H2.90918V5.81763ZM2.90918 14.5456V29.0911H29.091V14.5456H2.90918Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar.cd6b77c5daa094f34f86edf62b1a161a.svg";